<template>
    <pm-app-component hide-sidebar>

        <template slot="mobile-toolbar">
            <pm-application-bar simple>
               Frequently Asked Questions
            </pm-application-bar>
        </template>
        <pm-faq-item v-for="faq in faqs" :item="faq" />
        <br/>
    </pm-app-component>
</template>

<style>
    .pm-faq-topic-list {
        margin: 10px;
        padding: 16px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0,0,0,.08);
    }
    .pm-faq-topic-list h2 {
        margin-bottom: 10px;
    }
    .pm-faq-topic-list-item {
        border-top: 1px solid #f0f0f0;
        padding: 6px 0;
        margin-left: 30px;
    }
</style>

<script>
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmFaqItem from "./faq-questions-answers.vue"
import faqs from "./faq.js";

export default {
    components: {
        PmFaqItem,
    },
    mixins: [
        ToolbarMixin,
    ],
    data: () => {
        return ({
            faqs: faqs,
        });
    },
    toolbar() {
        const items = [];

            items.push({
                mdi: "mdiHelpCircleOutline",
                text: "Support",
                callback: () => {
                    this.$router.push("/support");
                },
            });

            items.push({
                active: true,
                mdi: "mdiCommentProcessingOutline",
                text: "F.A.Q.",
                callback: () => {
                    return false;
                },
            });

            // items.push({ placeholder: true });

            items.push({
                mdi: "mdiHumanMaleBoard",
                text: "Tutorials",
                callback: () => {
                    this.$router.push("/tutorials");
                },
            });

            // items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    this.$router.push("/");
                },
            });


        return ([items]);
    },
    methods: {
        toolbarBack() {
            this.$router.push("/");
        },

    },
};
</script>
